import React from "react";
import {Col} from "reactstrap";
const ServicesCard = (props) => {
    return (
      <>
        <Col lg={6} md={6} className="mt-5 align-items-stretch">
          <div
            className={
              props.isShadow
                ? "service-box text-center mt-4 box-shadow hover-effect h-100"
                : "service-box text-center mt-4 h-100"
            } onClick={props.onClick}
          >
            <img src={props.imgsrc} alt="" className="img-fluid" />
            <h5 className="fs-1 mt-4">{props.title}</h5>
            <div className="lighlight-border mt-4"></div>
            <p className="text-muted mt-3 fs-2">{props.caption}</p>
          </div>
        </Col>
        {/* <!--end col--> */}
      </>
    );
  }

export default ServicesCard;